import {
  Box,
  Text,
  Flex,
  VStack,
  HStack,
  Image as ChakraImage,
  IconButton,
} from "@chakra-ui/react";
import smrLogo from "@/assets/images/smr_img2.png";
import smrImage3 from "@/assets/images/smr_img3.png";
import SmrImageUploader from "./smrImageUpLoader";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectUser } from "@/reducer/userslice";
import { RiCloseCircleFill } from "@remixicon/react";
import SmrPictureControl from "../smrpicturecontrol/smrpicturecontrol";
import { imageUploaded } from "@/services/api/thunks/image";
import { RefStructure } from "@/types/design";
import { selectMode, updateRefStructure, updateWithandHeight, updateDesign, } from "@/reducer/modeslice";
import { useEffect } from "react";
import { refreshGenCoin } from "@/store/actions";

const SmrPicture = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const { design } = useAppSelector(selectMode);

  const handleChangeSmrPicture = async (files: File[]) => {
    files.map(async (file) => {
      const result: any = await dispatch(
        imageUploaded({
          file,
          image_category: "user",
          is_intermediate: false,
          imageType: "STRUCTURE_IMAGE",
          session_id: user.id,
        })
      );

      if (result) {
        let currentStructureImages: RefStructure[] = design.refstructure
          ? [...design.refstructure]
          : [];
        console.log(currentStructureImages, "1111");
        currentStructureImages.push({
          url: result.payload.image_url,
          weight: 1,
          refStructureType: "lineart",
          control_mode: "My prompt is more important"
        });
        console.log(currentStructureImages, "2222");
        dispatch(updateRefStructure(currentStructureImages))

        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target?.result) {
            const img = new Image();
            img.onload = () => {
              dispatch(updateWithandHeight({width: img.width, height:img.height }));
            };
            img.src = e.target.result as string;
          }
        };
        reader.readAsDataURL(file);
      }
    });
  };

  const handleDeleteSmrPicture = (image: RefStructure) => {
    
    let currentStructureImages = [...design.refstructure];
    const NewStructureArr = currentStructureImages.filter(
      (item) => item.url !== image.url
    );
    const newdesign = { ...design, refstructure: NewStructureArr };
    dispatch(updateDesign(newdesign));
  };

  useEffect(()=>{
    dispatch(refreshGenCoin())
  },[dispatch,design.refstructure])

  return (
    <Box
      background="linear-gradient(40.59deg, #496AE1 72.71%, #172147 86.65%)"
      borderRadius="10px"
      p="1px"
    >
      <Box
        borderRadius="10px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <Box
          p="20px"
          backgroundImage={`url('${smrLogo}')`}
          sx={{
            backgroundPosition: "top right",
            bgRepeat: "no-repeat",
          }}
        >
          <Flex>
            <VStack align={"center"} spacing="15px">
              <Text
                fontSize={"20px"}
                fontWeight="500"
                sx={{
                  bgGradient:
                    "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)",
                  backgroundClip: "text",
                  webkitBackgroundClip: "text",
                }}
              >
                毛坯房精装
              </Text>
              <Box
                w="72px"
                h="3px"
                background="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
              ></Box>
            </VStack>
          </Flex>
          <HStack mt="20px">
            <ChakraImage src={smrImage3} />
            <Text fontSize={"16px"} color="#FFFFFF">
              上传毛坯房或现场照片
            </Text>
          </HStack>
          <Box mt="8px" fontSize={"12px"} color="#6C7596">
            上传图像或将其拖动到此处，图片大小不能超过5M。
          </Box>

          <Box mt="20px">
            { design.refstructure && design.refstructure.length> 0 && (
              <Box
              h="200px"
              bg={"#0C0B10"}
              borderRadius="10px"
              position={"relative"}
              key={design.refstructure[design.refstructure.length-1].url}
            >
              <ChakraImage
                w="100%"
                h="200px"
                objectFit={"contain"}
                src={design.refstructure[design.refstructure.length-1].url}
              />
              <IconButton
                variant="unstyled"
                aria-label="delete"
                fontSize="16px"
                position={"absolute"}
                top="5px"
                right={"5px"}
                w="18px"
                minW={"18px"}
                h="18px"
                icon={<RiCloseCircleFill color="#6C7596" size={"18px"} />}
                onClick={() =>handleDeleteSmrPicture(design.refstructure[design.refstructure.length-1])}
              />
            </Box>
              )}
            {((design.refstructure && design.refstructure?.length < 1) ||
              !design.refstructure) && (
              <SmrImageUploader upDateImages={handleChangeSmrPicture} />
            )}

            {
              design.refstructure && design.refstructure.length>0 && <SmrPictureControl />
            }
            
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrPicture;
